<div class="card">
  <app-header [titulo]="titulo" [descricao]="descricao"></app-header>

  <div class="grid">
    <div class="col-6">
        <b>Instância:</b> {{ ordemOrigem.instancia  }} <br />
        <b>OS Origem:</b> {{ ordemOrigem.noOs  }} <br />
        <b>Situação:</b> {{ statusOrdem(ordemOrigem.fgSituacao)  }} <br />
        <b>Fazenda:</b> {{ ordemOrigem.deUpnivel1  }}
        <p-dropdown [style]="{'width':'100%'}" appendTo="body" [options]="depositosOrigem" optionLabel="cdDepositoErp" [(ngModel)]="depositoOrigem"></p-dropdown>
    </div>
    <div class="col-6">
      <span  *ngIf="tipoTransferencia == 'T'">
        <b>OS Destino: </b> <input id="destino" pInputText type="text" [(ngModel)]="ordemDestino.noOs" required autofocus (keydown.enter)="buscaOrdemDestino()"> <p-button icon="pi pi-search" severity="primary" aria-label="Acessar" class="ml-2" (click)="buscaOrdemDestino()" [loading]="loadingDestino"></p-button> <br />
        <b>Instância:</b> {{ ordemDestino.instancia  }} <br />
        <b>Situação:</b> {{ statusOrdem(ordemDestino.fgSituacao)  }} <br />
        <b>Fazenda:</b> {{ ordemDestino.deUpnivel1  }} <br />
      </span>
      <span>
        <p-dropdown [style]="{'width':'100%'}" appendTo="body" [options]="depositosDestino" optionLabel="cdDepositoErp" [(ngModel)]="depositoDestino"></p-dropdown>
        <p-dropdown [style]="{'width':'100%'}" appendTo="body" [options]="depositoDestino.posicoes" placeholder="Seleciona uma posição" optionLabel="dePosicao" [(ngModel)]="posicaoDestino"></p-dropdown>
      </span>
    </div>
  </div>
  <p-table
    [value]="ordemOrigem.itens"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [resizableColumns]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th colspan="4"></th>
        <th colspan="8">Quantidades</th>
        <th colspan="2">Saldos</th>
        <th></th>
      </tr>
      <tr>
        <th>Data</th>
        <th>Insumo</th>
        <th>Descrição</th>
        <th>Unidade</th>
        <th>Estoque ERP</th>
        <th>Ajustada</th>
        <th>Compromissada</th>
        <th>Retirada</th>
        <th>Recebida</th>
        <th>Transferida</th>
        <th>Devolvida</th>
        <th>Baixada PIMS</th>
        <th  [attr.colspan]="tipoTransferencia == 'T' ? 1 : 2">OS Origem</th>
        <th *ngIf="tipoTransferencia == 'T'">OS Destino</th>
        <th>Quantidade a enviar</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ formatDate(item.dtRefer) }}</td>
        <td>{{ item.cdInsumo }}</td>
        <td>{{ item.deInsumo }}</td>
        <td>{{ item.cdUnimed }}</td>
        <td><div *ngIf="loadingEstoqueERP; else elseBlock"><p-progressSpinner ariaLabel="loading" strokeWidth="2" styleClass="w-1rem h-1rem"></p-progressSpinner></div><ng-template #elseBlock>{{ estoqueMaterialErp[item.cdInsumoErp]?.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2}) || (0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</ng-template></td>
        <td>{{ item.qtAjustada.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  }} </td>
        <td>{{ item.qtCompromissadaOs.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  }} </td>
        <td style="color: green">{{ item.qtRetirada.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || (0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})}}</td>
        <td style="color: green">{{ item.qtRecebida.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || (0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) }}</td>
        <td style="color: red">{{ item.qtEnviada.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || (0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) }}</td>
        <td style="color: red">{{ item.qtDevolvida.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) || (0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) }}</td>
        <td style="color: red">{{ getBaixado(item.cdInsumo).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) || (0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) }}</td> 
        <td [attr.colspan]="tipoTransferencia == 'T' ? 1 : 3">{{ calculaMaximo(item).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || (0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3}) }}</td>
        <td *ngIf="tipoTransferencia == 'T'">{{ buscaSaldoDestino(item.cdInsumo).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  }}</td>
        <td><p-inputNumber mode="decimal" inputId="minmaxfraction" [minFractionDigits]="3" [maxFractionDigits]="3" [min]="0" [max]="calculaMaximo(item) || 0" [(ngModel)]="transferencias[item.cdInsumo].quantidade" [showButtons]="true" [disabled]="item.bloqueado" /></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
        <div class="flex flex-wrap align-items-right justify-content-between w-full">
            <p-button icon="pi pi-arrow-up-right" [severity]="corBotao" aria-label="Transferir" [label]="botao" [loading]="loadingOperacao" [disabled]="loadingOperacao" (click)="transferir()"></p-button>
        </div>
    </ng-template>
  </p-table>
</div>